export function PlayIcon({
    className,
}: {
    className?: string;
}) {
    return (
        <svg className={className} width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2634_20136)">
                <path d="M1.65186 12.9556V3.87842C1.65186 3.50179 1.74919 3.22249 1.94385 3.04053C2.13851 2.85433 2.36914 2.76123 2.63574 2.76123C2.87272 2.76123 3.10758 2.82894 3.34033 2.96436L10.9194 7.38232C11.1987 7.54736 11.4019 7.70605 11.5288 7.8584C11.66 8.01074 11.7256 8.19694 11.7256 8.41699C11.7256 8.63281 11.66 8.81901 11.5288 8.97559C11.4019 9.12793 11.1987 9.28451 10.9194 9.44531L3.34033 13.8696C3.10758 14.005 2.87272 14.0728 2.63574 14.0728C2.36914 14.0728 2.13851 13.9797 1.94385 13.7935C1.74919 13.6073 1.65186 13.328 1.65186 12.9556Z" fill="#101828" />
            </g>
            <defs>
                <clipPath id="clip0_2634_20136">
                    <rect width="12" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>

    );
}

PlayIcon.displayName = 'PlayIcon';
